import React from 'react';
import ReactTooltip from 'react-tooltip';
import axios from 'axios';
import AxiosConfig from '../../../utilities/AxiosConfig';

export interface IProps {
    ticketId: number;
}

const ImageCounter: React.FC<IProps> = (props: IProps) => {
    const { ticketId } = props;
    const [imageCount, setImageCount] = React.useState(null);

    const getImageCount = (e: React.MouseEvent) => {
        e.preventDefault();
        if(imageCount === null){
            axios.get(process.env.REACT_APP_API_URL + "/api/ticketquery/getticketpicturecount?ticketId=" + ticketId, AxiosConfig.configValue("min"))
            .then((res: any) => {
                //console.log(res);
                setImageCount(res.data);
            })
            .catch((err: any) => {
                //console.log(err);
            })
        }
    }

    return (
        <>
            <ReactTooltip id={ticketId.toString()} place="right" effect="solid">{imageCount === null ? "Loading..." : `${imageCount} Picture${Number(imageCount) > 1 ? "s" : ""}`}</ReactTooltip>
            <i onMouseEnter={getImageCount} data-for={ticketId.toString()} data-tip="" className="material-icons">insert_photo</i>
        </>
    );
}

export default ImageCounter;